import React from 'react';
import cn from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import classes from '../cart-item/cart-item.scss';
const tooltipStyles = {
  popper: classes.boxEditBtnTooltipPopper,
  tooltip: classes.tooltipRoot
};
const Quantity = ({
  isBoxItemInDraft,
  isQuantityClickable,
  tooltipText,
  isItemBoxSpecialNotecard,
  isSwagSampleBox,
  isOutOfStock,
  quantity,
  isLERestricted,
  handleOnQuantityClick
}) => {
  return isBoxItemInDraft ? /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipText,
    placement: Placement.RIGHT,
    mode: "light",
    className: classes.infoWrapper,
    classes: tooltipStyles
  }, /*#__PURE__*/React.createElement("span", {
    className: cn(classes.quantityHolder, {
      [classes.clickable]: isQuantityClickable
    }),
    onClick: isQuantityClickable ? handleOnQuantityClick : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondaryTitle
  }, "Quantity:"), /*#__PURE__*/React.createElement("b", {
    className: cn(classes.prodPricePink, classes.alignmentClass, classes.withoutPadding, {
      [classes.greyedOut]: isSwagSampleBox || isItemBoxSpecialNotecard || isOutOfStock || isBoxItemInDraft
    }),
    "data-text": "Quantity"
  }, quantity))) : /*#__PURE__*/React.createElement("span", {
    className: cn(classes.quantityHolder, {
      [classes.clickable]: isQuantityClickable
    }),
    onClick: isQuantityClickable ? handleOnQuantityClick : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.secondaryTitle
  }, "Quantity:"), /*#__PURE__*/React.createElement("b", {
    className: cn(classes.prodPricePink, classes.alignmentClass, classes.withoutPadding, {
      [classes.greyedOut]: isSwagSampleBox || isItemBoxSpecialNotecard || isOutOfStock || isBoxItemInDraft || isLERestricted
    }),
    "data-text": "Quantity"
  }, quantity));
};
export default Quantity;